import navigationData from "../../app/navigation/generated/navigation-data";

const GENERIC_ACTION_LABELS = {
    read: "查看",
    read_basic: "查看基本信息",
    view: "查看",
    create: "新建",
    update: "修改",
    delete: "删除",
    manage: "管理",
    export: "导出",
    import: "导入",
    write: "写入",
    publish: "发布",
    confirm: "确认",
    revert: "撤回",
    deprecate: "废弃",
    allocate: "分摊",
    sync: "同步",
    admin: "管理配置",
    run: "执行",
};

function permissionCodes(routePermission) {
    if (!routePermission) return [];
    return (Array.isArray(routePermission) ? routePermission : [routePermission]).filter(Boolean);
}

function resourceOf(code) {
    const text = String(code || "");
    const index = text.indexOf(":");
    return index === -1 ? text : text.slice(0, index);
}

function actionOf(code) {
    const text = String(code || "");
    const index = text.lastIndexOf(":");
    return index === -1 ? "" : text.slice(index + 1);
}

function pageName(page) {
    return page.frontend === "new" ? `${page.label}（Portal）` : page.label;
}

function collectPages(data) {
    const sectionLabelByKey = Object.fromEntries((data.sections || []).map((section) => [section.key, section.label]));
    const menuLabelByKey = {};
    (data.routes || []).forEach((route) => {
        if (route.menu && route.menuLabel) {
            menuLabelByKey[route.key] = route.menuLabel;
        }
    });

    const pages = [];
    (data.routes || []).forEach((route) => {
        const codes = [...new Set([...permissionCodes(route.routePermission), ...permissionCodes(route.menuPermission)])];
        if (codes.length === 0) return;
        const label = route.menuLabel || route.pageLabel || menuLabelByKey[route.activeMenuKey] || "";
        if (!label) return;
        pages.push({
            label,
            sectionLabel: sectionLabelByKey[route.sectionKey] || "",
            frontend: route.frontend || "old",
            codes,
            resources: [...new Set(codes.map(resourceOf))],
        });
    });
    return pages;
}

const pages = collectPages(navigationData);

function uniquePages(candidates) {
    const seen = new Set();
    return candidates.filter((page) => {
        const key = `${page.frontend}|${page.sectionLabel}|${page.label}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
}

/**
 * 把权限码对到导航里的页面。
 * 精确命中表示这个权限本身就能进入页面；
 * 否则按权限码第一段，归到同一入口下的页面（新建、修改、删除通常不是入口权限）。
 */
export function describePermissionUsage(code, description) {
    const exact = uniquePages(pages.filter((page) => page.codes.includes(code)));
    const resource = resourceOf(code);
    const related = exact.length > 0 ? [] : uniquePages(pages.filter((page) => page.resources.includes(resource)));
    const matched = exact.length > 0 ? exact : related;
    const actionText = description || GENERIC_ACTION_LABELS[actionOf(code)] || actionOf(code) || "";

    if (matched.length === 0) {
        return {
            relation: "none",
            pages: [],
            actionText,
            summary: "未挂到菜单页面",
            searchText: "未挂到菜单页面",
        };
    }

    const names = matched.map(pageName);
    const visibleNames = names.slice(0, 3).map((name) => `「${name}」`).join("");
    const more = names.length > 3 ? ` 等 ${names.length} 个页面` : "";
    const lead = exact.length > 0 ? "进入" : "用于";
    const summary = actionText ? `${lead}${visibleNames}${more} · ${actionText}` : `${lead}${visibleNames}${more}`;

    return {
        relation: exact.length > 0 ? "enter" : "operate",
        pages: matched.map((page) => ({
            label: pageName(page),
            sectionLabel: page.sectionLabel,
        })),
        actionText,
        summary,
        searchText: `${names.join(" ")} ${summary}`,
    };
}
